import { render, staticRenderFns } from "./ProductEditGroupsLight.vue?vue&type=template&id=5e063394"
import script from "./ProductEditGroupsLight.vue?vue&type=script&lang=ts"
export * from "./ProductEditGroupsLight.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e063394')) {
      api.createRecord('5e063394', component.options)
    } else {
      api.reload('5e063394', component.options)
    }
    module.hot.accept("./ProductEditGroupsLight.vue?vue&type=template&id=5e063394", function () {
      api.rerender('5e063394', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/ProductEditGroupsLight.vue"
export default component.exports